class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          if (section.block === "cart-items") {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);


document.addEventListener('DOMContentLoaded', function() {
  initCartUpsellFeature();
});

function initCartUpsellFeature() {
  const slider = document.getElementById('CartUpsellSlider');
  if (!slider) return;

  // 1. إضافة المنتج وتحديث محتوى الكارت لحظياً
  slider.addEventListener('click', function(e) {
    const btn = e.target.closest('.upsell-add-btn');
    if (!btn || btn.disabled) return;

    const variantId = btn.getAttribute('data-variant-id');
    const productId = btn.getAttribute('data-product-id');
    const card = document.getElementById('upsell-card-' + productId);

    const label = btn.querySelector('.btn-label');
    const loading = btn.querySelector('.btn-loading');

    // تغيير حالة الزرار للتحميل
    btn.disabled = true;
    if (label) label.style.display = 'none';
    if (loading) loading.style.display = 'inline';

    // أ) إضافة المنتج للكارت
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }]
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add');
      return response.json();
    })
    .then(() => {
      // ب) إخفاء كارت المنتج المُضاف
      if (card) {
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        setTimeout(() => card.remove(), 300);
      }

      // ج) جلب وتحديث محتوى الكارت لحظياً بدون ريفريش للصفحة
      return fetch(window.location.pathname + '?section_id=cart-drawer');
    })
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // تحديث قائمة المنتجات في الكارت
      const newItems = doc.querySelector('.m-cart-drawer__body') || doc.querySelector('.m-cart-drawer__items');
      const currentItems = document.querySelector('.m-cart-drawer__body') || document.querySelector('.m-cart-drawer__items');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      // تحديث الجزء الخاص بالإجمالي والأسعار
      const newFooter = doc.querySelector('.m-cart-drawer__footer');
      const currentFooter = document.querySelector('.m-cart-drawer__footer');
      if (newFooter && currentFooter) {
        // تحديث محتوى الفوتر مع الحفاظ على الـ Upsell Slider
        const upsellWrapper = currentFooter.querySelector('.cart-upsell-wrapper');
        currentFooter.innerHTML = newFooter.innerHTML;
        if (upsellWrapper && !currentFooter.querySelector('.cart-upsell-wrapper')) {
          currentFooter.insertBefore(upsellWrapper, currentFooter.firstChild);
        }
      }

      // د) إطلاق الأحداث الخاصة بالثيم لتحديث عدد المنتجات في الهيدر (Cart Count Badge)
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    })
    .catch(error => {
      console.error('Error adding upsell item:', error);
      btn.disabled = false;
      if (label) label.style.display = 'inline';
      if (loading) loading.style.display = 'none';
    });
  });

  // 2. الـ Auto Slider للموبايل (كل 4 ثواني)
  let autoSlideTimer = null;

  function startAutoSlide() {
    // تم إزالة شرط توقف السلايدر في الديسكتوب
    
    stopAutoSlide();
    autoSlideTimer = setInterval(() => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      
      if (slider.scrollLeft >= maxScroll - 10) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const cardWidth = slider.querySelector('.cart-upsell-card')?.offsetWidth || 250;
        slider.scrollBy({ left: cardWidth + 10, behavior: 'smooth' });
      }
    }, 4000);
  }

  function stopAutoSlide() {
    if (autoSlideTimer) clearInterval(autoSlideTimer);
  }

  startAutoSlide();
  slider.addEventListener('touchstart', stopAutoSlide, { passive: true });
  slider.addEventListener('mouseleave', startAutoSlide);
}